import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    template: `
        <router-outlet></router-outlet>
        <app-support-bubble [expanded]="isAccountPage"></app-support-bubble>
    `
})
export class RootComponent {
    constructor(private _router: Router) { }
    get isAccountPage(): boolean {
        return this._router.url.startsWith('/account');
    }
}
